//VariantFacts.vue



<template>

	<div class="container">

		<div class="variant-container">
			
				<div class="variant-facts" v-for="(buildingResult, index) in this.$store.state.buildingResults" v-bind:key="buildingResult">

						<div class="container-icon-variant" v-bind:id="index" @click="getCarbonRate">
							V{{ index + 1 }}
						</div>

						<p class="variant-text">
							Material: {{ buildingResult.material }}, System: {{ buildingResult.system }}, Grid: {{ buildingResult.grid }}, <br>
							Live Load: {{ buildingResult.load}} kN/m&sup2;, Cost: {{ buildingResult.cost.toLocaleString() }} EUR, Ceiling Height: {{ buildingResult.structCeilingHeight}} m, <br> 
							Structural Weight: {{ buildingResult.weight.toLocaleString() }} t, Embodied Carbon: {{ buildingResult.carbonData.toLocaleString() }} kg CO<sub>2</sub> e 
						</p>

				</div>

		</div>

	</div>
  
</template>



<script>

//Import

// var buildingResults = this.$store.state.buildingResults


import * as MyFunctions from "../MyFunctions.js";

import gsap from "gsap";


export default {
	components: {

	},
	emits: [
		'carbonRate'
	],
	data() {
		return {
			// buildingResults,
			msg: "",
			carbonRate: '',
			variantIndex: ''
		};
	},
	methods: {
		init() {
			//Logging results
			// console.log('this.$store.state.buildingResults from VariantFacts.vue');
			// console.log(this.$store.state.buildingResults);
		},
		getCarbonRate(e) {
			var selectedVariant = e.target.outerText;
			var index = selectedVariant.charAt(selectedVariant.length - 1);
			var buildingResults = this.$store.state.buildingResults;
			var carbonPerM2 = buildingResults[index - 1].carbonData / buildingResults[index - 1].surfaceArea; 
			this.$store.state.carbonValue = carbonPerM2;

			var co2PerLongDistanceFlight = 1000; 							//kg per flight from FFm to NYC -> https://co2.myclimate.org/en/portfolios?calculation_id=4610642 
			var flightCount = (buildingResults[index - 1].carbonData / co2PerLongDistanceFlight).toFixed(1); 
			this.$store.state.flightCount = flightCount;

			var variantIndex = e.target.id;
			this.variantIndex = variantIndex;
		},
	},
	mounted() {
		this.init();
	},
	watch: {
		variantIndex: {
			handler(newVal, oldVal) {
				this.$store.state.selectedVariant = newVal;

				// console.log(this.$store.state.selectedVariant);

				var currentIndex = document.getElementById(newVal.toString()); 
				var previousIndex = document.getElementById(oldVal.toString()); 

				gsap.to(currentIndex, { duration: .4,  scale: (1.1)});
				gsap.to(currentIndex, { duration: .4,  color: ('rgba(255, 255, 255, 1)')});
				gsap.to(previousIndex, { duration: .4,  scale: (1.0)});
				gsap.to(previousIndex, { duration: .4,  color: ('rgba(255, 255, 255, 0.7)')});
			}
		}
	}
};

</script>



<style>

.container {
	/* width: 500px;
	height: 600px; */
	/* padding: 10px; */
}

.variant-container {
	padding: 0 0;
	/* border: 1px solid black; */
	background: transparent;
}

.variant-facts {
	/* border: 1px solid black; */
	height: 100%;
	padding: .55rem 0;
	margin-top: 0px;
	font-size: .9rem;
	text-align: left;
	border-bottom: 1px dotted black;
	/* border-bottom-color: rgba(35, 35, 35, 0.5); */
	display: flex;
}

.variant-facts:first-child {
	margin-top: 0;
	/* border: none; */
}

.variant-facts:last-child {
	border: none;
}

.variant-grid {
	display: grid;
	grid-template-rows: auto;
	grid-template-columns: auto auto;
}

.variant-text {
	grid-column: 2;
	grid-row: 2;
	font-weight: 400;
	margin-top: 0px;
	margin-bottom: 0px;
	font-size: .60rem;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	color: rgb(83, 83, 83);
}

.container-icon-variant {
	color: rgba(255, 255, 255, 0.7);
	line-height: 2.6rem;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-size: 1rem;
	font-weight: 500;
	text-align: center;
	align-content: center;
	margin-left: 0;
	border-radius: 10px;
	height: 2.6rem;
	width: 2.6rem;
	background: rgb(0, 0, 0);
	margin-right: 1rem;
	cursor: pointer;
	/* border: 1px solid rgba(49, 49, 49, 0.2); */
}

.container-icon-variant:hover {
	-webkit-transform: scale(1.05);
	transform: scale(1.05);
	transition: 0.1s ease-out;
} 

.container-icon-variant:active {
	color: rgba(255, 255, 255, 1);
} 

</style>